import React,
{
  Component,
} from 'react'

class PlanNotStarted extends Component {
  createFinancialPlan(clientId) {
    const routeObj = ADV.util.Router.getObjFromHash(
      `editplan/${clientId}`
    );
    if (!routeObj) {
      throw "[PlanNotStarted]: The route is incorrect";
    }
    ADV.util.Router.go2(routeObj.id, routeObj.params);
  }
  render() {
    return <div id="PlanNotStarted" className="MissingInfo">
      <h1 className="small">You have not yet created a financial plan.</h1>
      <i className="far fa-edit"></i>
      <button onClick={() => this.createFinancialPlan(this.props.clientId)}>
          Create a Financial Plan
      </button>
    </div>
  }
}

export default PlanNotStarted;
